<div class="mat-dialog-container">
	<div class="mat-dialog-header">
		<h2 mat-dialog-title>{{ "ORDER_BASKET.PRICE_SUMMARY_DIALOG.TITLE" | translate }}</h2>
		<div class="cass-toggle-button-container">
			<div class="cass-toggle-button-group">
				<mat-label class="cass-toggle-group-label">{{"ORDER_BASKET.PRICE_SUMMARY_DIALOG.PRIMARY_GROUP_LABEL" | translate}}</mat-label>
				<mat-button-toggle-group multiple [(ngModel)]="primaryGroup" (change)="onPrimaryGroupingChange($event)">
					<ng-container *ngFor="let option of orderLinesTableColumnDefs">
						<mat-button-toggle *ngIf="option.isGroupingColumn" value="{{ option.key }}">
							{{ option.heading | translate}}
						</mat-button-toggle>
					</ng-container>
				</mat-button-toggle-group>
			</div>
			<div class="cass-toggle-button-group">
				<mat-label class="cass-toggle-group-label">{{"ORDER_BASKET.PRICE_SUMMARY_DIALOG.SECONDARY_GROUP_LABEL" | translate}}</mat-label>
				<mat-button-toggle-group [(ngModel)]="secondaryGroup" (change)="onSecondaryGroupingChange($event)">
					<ng-container *ngFor="let option of orderLinesTableColumnDefs">
						<mat-button-toggle *ngIf="option.isGroupingColumn" value="{{ option.key }}">
							{{ option.heading | translate}}
						</mat-button-toggle>
					</ng-container>
					<mat-button-toggle (click)="clearAllSecondaryGrouping()" value="">
						{{"ORDER_BASKET.PRICE_SUMMARY_DIALOG.TOGGLE_BUTTON_LABELS.NONE" | translate}}
					</mat-button-toggle>
				</mat-button-toggle-group>
			</div>
		</div>
	</div>

	<mat-divider></mat-divider>
	<div #dialogContainer mat-dialog-content>
		<div cassStickyTableHeader
			 [parentContainer]="dialogContainer"
			 styleClass="cass-summary-table-sticky-header"
			 class="table-container">
			<table  mat-table [dataSource]="dataSource || []">
				<ng-container *ngFor="let column of orderLinesTableColumnDefs" [matColumnDef]="column.key">
					<th mat-header-cell *matHeaderCellDef
						class="{{ column.class }}">{{ column.heading | translate }}</th>
					<td mat-cell *matCellDef="let row"
						class="{{ column.class }} {{(row.isAggregateRow) ? 'text-bolder' : ''}}">
						{{ column.value ? column.value(row) : row[column.key] }}
					</td>
				</ng-container>
				<tr mat-header-row *matHeaderRowDef="orderLinesTableDisplayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: orderLinesTableDisplayedColumns"></tr>
			</table>
		</div>
	</div>
	<mat-divider></mat-divider>
	<div mat-dialog-actions>
		<button class="float-right" mat-button (click)="closeDialog()">{{"ORDER_BASKET.PRICE_SUMMARY_DIALOG.ACTION_BUTTON_LABELS.CLOSE" | translate}}</button>
	</div>
</div>
